import React from 'react';
import PropTypes from 'prop-types';

import Preview from './preview';
import PreviewHeader from './editor/preview_header';

const ReadOnlyPreview = ({ html, message, onlyWeb, updating }) => {
  const header = !message ? null : (
    <PreviewHeader
      deliveryOptions={message.delivery}
      message={message}
    />
  );

  return (
    <Preview
      contentHeader={header}
      html={html}
      onlyWeb={onlyWeb}
      readOnly={true}
      updating={updating}
    />
  );
};

ReadOnlyPreview.propTypes = {
  html: PropTypes.string.isRequired,
  message: PropTypes.object,
  onlyWeb: PropTypes.bool,
  updating: PropTypes.bool
};

export default ReadOnlyPreview;
